<template>
  <div class="company-complete">
    <img src="../../assets/success-2233.png" alt="">
    <p class="company-complete-text">您已完成信息提交，后台审核通过后即可创建应用。请先前往文档中心获取更多信息！</p>
    <div class="company-complete-bottom">
      <router-link :to="{name: 'doc'}">
        <bcc-button size="max-large" type="primary" @click="$LogReport.sendCustomEvent('openplat_developsubmit_filecenter_click')">进入文档中心</bcc-button>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "companyComplete",
  created() {
    this.$store.dispatch('getCompanyInfo')
  }
}
</script>

<style scoped lang="scss">
.company-complete {
  max-width: 1168px;
  min-width: 960px;
  margin: 0 auto;
  text-align: center;

  img {
    margin-top: 134px;
    height: 205px;
    width: auto;
  }

  .company-complete-text {
    font-size: 16px;
    line-height: 24px;
    color: #212121;
    margin-top: 34px;
  }

  .company-complete-bottom {
    margin: 32px 0;
  }
}
</style>
